const delayShowPrice = () => {
    setTimeout(() => {
        BSS_B2B?.observer?.cartSubject?.notifyObserver?.('CartMutate', 'CartPriceMutate');
    }, 3000);
}

delayShowPrice();

const customCustomField = (customFieldValue) => {
    const invoiceTypeInput = document.querySelectorAll(`.nu-invoice__type input[name="nu_invoice_type"]`);
    const invoiceLabel = document.querySelector(`.nu-invoice__type legend.custom-field-label`);
    let invoiceType = "";
    invoiceTypeInput.forEach(input => {
        if (input.checked) {
            invoiceType = input.value;
            customFieldValue.push({ key: invoiceLabel.innerText, value: input.value });
        };
    })
    const appSelect = document.querySelector("select#app-select");
    const appSelectLabel = document.querySelector(`#row-application label[for="app-select"]`);
    if (appSelect) customFieldValue.push({ key: (appSelectLabel?.innerText || "Application")?.replace(" *", ""), value: appSelect.value });
    const iecInput = document.querySelector("textarea#iec-input");
    if (iecInput) customFieldValue.push({ key: "IEC.No", value: iecInput.value });
    const vatInput = document.querySelector("textarea#vat-input");
    if (vatInput) customFieldValue.push({ key: "VAT No", value: vatInput.value });
    const clearanceType = document.querySelectorAll(`#row-customs .custom-radio-group input.custom-radio-req`);
    const clearanceLabel = document.querySelector("#row-customs label.custom-field-label");
    clearanceType.forEach(input => {
        if (input?.checked) customFieldValue.push({ key: (clearanceLabel.innerText)?.replace(" *", ""), value: input.value });
    })
    customFieldValue.push({ key: "Privacy Policy Agreed Time", value: new Date().toISOString() });
    customFieldValue.push({ key: "Due Diligence Agreed Time", value: new Date().toISOString() });
    if (invoiceType === "company") {
        const taxIdInput = document.querySelector("#nu-invoice-tax-id");
        const taxIdLabel = document.querySelector(`label[for="nu-invoice-tax-id"]`);
        if (taxIdInput) customFieldValue.push({ key: (taxIdLabel?.innerText || "公司統編").replace(" *", ""), value: taxIdInput.value });
        const companyTitle = document.querySelector("#nu-invoice-company-title");
        const companyTitleLabel = document.querySelector(`label[for="nu-invoice-company-title"]`);
        if (companyTitle) customFieldValue.push({ key: (companyTitleLabel?.innerText || "公司抬頭").replace(" *", ""), value: companyTitle.value });
    }
    customFieldValue = customFieldValue.filter(item => item.value);
    return customFieldValue;
}

window?.BSS_B2B?.custom?.addFilter?.('custom:order_additional_details/checkout', customCustomField);

const BLOCKED_COUNTRIES = [
    { code: 'TW', name: 'taiwan' },
    { code: 'AF', name: 'afghanistan' },
    { code: 'CG', name: 'congo' },       
    { code: 'CD', name: 'congo' },      
    { code: 'CF', name: 'central african' },
    { code: 'CU', name: 'cuba' },
    { code: 'IQ', name: 'iraq' },
    { code: 'IR', name: 'iran' },
    { code: 'KP', name: 'north korea' },
    { code: 'LB', name: 'lebanon' },
    { code: 'LY', name: 'libya' },
    { code: 'SD', name: 'sudan' },
    { code: 'SO', name: 'somalia' },
    { code: 'SS', name: 'south sudan' },
    { code: 'SY', name: 'syria' },
    { code: 'RU', name: 'russia' },
    { code: 'IL', name: 'israel' },
];

const isBlockedOption = (opt) => {
    const val = opt.value.trim().toUpperCase();
    const text = opt.textContent.trim().toLowerCase();
    return BLOCKED_COUNTRIES.some(c =>
        val === c.code || text.includes(c.name)
    );
};

const removeBlockedFrom = (select) => {
    if (!select) return;
    const options = Array.from(select.querySelectorAll('option')).filter(isBlockedOption);
    if (!options.length) return;
    const wasSelected = options.some(opt => opt.selected);
    options.forEach(opt => opt.remove());
    if (wasSelected && select.options.length) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }
};

const scanAndRemoveBlocked = (root = document) => {
    root.querySelectorAll('select#countryCode, select[name*="country" i], select[id*="country" i]')
        .forEach(removeBlockedFrom);
    root.querySelectorAll('*').forEach(el => {
        if (el.shadowRoot) {
            scanAndRemoveBlocked(el.shadowRoot);
            observeRoot(el.shadowRoot);
        }
    });
};

const observedRoots = new WeakSet();
const observeRoot = (root) => {
    if (observedRoots.has(root)) return;
    observedRoots.add(root);
    const mo = new MutationObserver(() => scanAndRemoveBlocked(root));
    mo.observe(root, { childList: true, subtree: true });
};

observeRoot(document);
scanAndRemoveBlocked();